module.exports = __webpack_public_path__ + "assets/milk-bottle-2.e2b00e3a.svg";